import './ccf-accordion.module.scss';
import { Accordion, AccordionProps } from '@mui/material';


/**
 * CcfAccordion used to display react accordion
 * @param param - AccordionProps
 * @example <CcfAccordion />
 */
export function CcfAccordion({children, ...rest}: AccordionProps) {
  return <Accordion {...rest}>{children}</Accordion>
}

export default CcfAccordion;